<template>
  <v-container class="p-order" v-scroll="onScroll">
    <c-section title="保单管理">
      <v-layout class="link-wrap mb-2" ref="statusList">
        <template v-for="(item,index) in statusList">
          <a
            :key="item.title"
            :class="{active:query.status === item.value}"
            class="search-status"
            @click="query.status = item.value"
          >{{ item.title }}</a>
          <div :key="index" v-if="index < statusList.length - 1" class="vertical"></div>
        </template>
      </v-layout>
      <div class="form-item">
        <v-flex class="form-item">
          <label>投保人</label>
           <v-text-field
            v-model="applicantName"
            :solo="solo"
          ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
          <label>保单号</label>
           <v-text-field
            v-model="no"
            :solo="solo"
          ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
          <label>投保日期</label>
            <v-menu
                ref="dateMenu"
                v-model="endDateMenuVisible"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
            <v-text-field
                slot="activator"
                class="date-input"
                v-model="sumbitTime"
                placeholder="请选择时间"
                :solo="solo"
                append-icon="calendar_today"
                readonly
            ></v-text-field>
            <v-date-picker
                v-model="sumbitTime"
                :header-date-format="(date) => date"
                no-title
                @input="endDateMenuVisible = false"
            ></v-date-picker>
            </v-menu>
        </v-flex>
        <v-btn color="primary" class="search-btn" @click="searchOder">搜索</v-btn>
        <v-btn color="primary" class="search-btn" @click="reset">重置</v-btn>
      </div>
      <div class="order-list" v-loading="false">
        <ListItem v-for="(item,i) in orderList" :key="i" :order="item" @update="upData"></ListItem>
      </div>
      <div class="introduce-text text-xs-center mt-4">
        <span v-if="totalPage > page.pageIndex">每页 10 条数据，滚动页面继续加载下一页</span>
        <span v-else>数据已加载完毕</span>
      </div>
    </c-section>
  </v-container>
</template>

<script>
import ListItem from "./components/ListItem";
export default {
  components: {
    ListItem
  },
  data() {
    return {
      endDateMenuVisible:false,
      applicantName:"",
      no:"",
      sumbitTime:"",
      solo:true,
      loading: true,
      statusList: [
        { title: "全部", value: -1 },
        { title: "已出单", value: 1 },
        { title: "待支付", value: 0 }
      ],
      query: {
        status: -1
      },
      page: {
        pageIndex: 1, // 从1开始
        pageSize: 10,
        totalSize: 0
      },
      orderList: [],
      heightTotal:0
    };
  },
  computed: {
    totalPage() {
      if (this.page.totalSize % this.page.pageSize === 0) {
        return this.page.totalSize / this.page.pageSize;
      }
      return parseInt(this.page.totalSize / this.page.pageSize) + 1;
    }
  },
  watch: {
    "page.pageIndex"() {
      this.getData();
    },
    "query.status"() {
      this.pageIndex= 1;// 从1开始
      this.orderList = [];
      this.getData();
    },
    heightTotal(){
      this.page.pageIndex = this.page.pageIndex + 1;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    reset(){
      this.applicantName=""
      this.no=""
      this.sumbitTime=""
    },
    searchOder(){
      this.page.pageIndex = 1
      this.orderList= []
      this.getData()
    },
    upData(val){
      if(val){
        this.searchOder()
      }
    },
    getData() {
      this.loading = true;
      const params = Object.assign(
        {
          pageIndex: this.page.pageIndex, // 接口是从0开始的
          pageSize: this.page.pageSize,
          applicantName:this.applicantName,
          no:this.no,
          sumbitTime:this.sumbitTime
        },
        this.query
      );
      if(this.applicantName===""){
        delete params.applicantName
      }
      if(this.no===""){
        delete params.no
      }
      if(this.sumbitTime===""){
        delete params.sumbitTime
      }
      this.$axios
        .get("/app/api/myPolicy/listPolicy", {
          params
        })
        .then(res => {
          this.loading = false;
          let arr = res.data;
          this.orderList = [...this.orderList,...arr];
          this.page.totalSize = res.total;
          // setTimeout(() => {
          //   this.$vuetify.goTo(50);
          // }, 100);
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("订单查询异常：" + err);
        });
    },
    onScroll() {
      if (this.page.pageIndex <= this.totalPage) {
        const totalHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const scrollTop = document.documentElement.scrollTop;
        if (scrollTop + clientHeight > totalHeight - 100) {
          this.heightTotal = totalHeight
          // this.page.pageIndex = this.page.pageIndex + 1;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-btn{
  margin-top: 0px;
}
.p-order {
  .link-wrap {
    .search-status,
    .vertical {
      margin-right: 30px;
    }
    .search-status {
      color: #666666;
    }
  }
}
</style>

